import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initI18n } from './i18n';

// Fire-and-forget — i18n init resolves the cookie locale + fetches
// admin-edited overrides. Render is unblocked: components default to
// bundled JSON until the resource bundle is hydrated.
initI18n();

// Persist traffic source from URL across navigation (e.g. utm_source=emercadohub-app from WebView)
const params = new URLSearchParams(window.location.search);
const utmSource = params.get('utm_source');
if (utmSource) {
  sessionStorage.setItem('utm_source', utmSource);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
